import React from 'react';

const CreateCurrencyConversionRate = () => {
  return <div>CreateCurrencyConversionRate</div>;
};

export default CreateCurrencyConversionRate;
